module.exports = __webpack_public_path__ + "img/transcript_envirothon_asia.f9a9c382.png";